// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3PMGL","colMaxWidth":"Table_colMaxWidth__31XzZ"};